import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16b532e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("title", null, "How about the Blog | Zetreex", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  name: "description",
  content: "Zetreex, Software Development Company - These are our valuable blog!"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:url",
  content: "https://zetreex.com/blog"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:title",
  content: "How about the Blog | Zetreex"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("link", {
  rel: "canonical",
  href: "https://zetreex.com/blog"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:description",
  content: "Zetreex, Software Development Company - These are our valuable blog!"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "url",
  content: "https://zetreex.com/blog"
}, null, -1))
const _hoisted_8 = { class: "blogs-container" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "blog-for_mobile" }
const _hoisted_11 = { class: "layout_filter" }
const _hoisted_12 = {
  key: 0,
  class: "blogs_cont"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "blog__element_inner" }
const _hoisted_16 = { class: "blog__element_date" }
const _hoisted_17 = { class: "blog__element_text" }
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  id: "medium",
  width: "38",
  height: "38",
  viewBox: "0 0 38 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.3208 12.488C8.33795 12.3206 8.31498 12.1516 8.25372 11.9945C8.19246 11.8374 8.09461 11.6966 7.968 11.5833L5.3528 8.46613V8H13.47L19.7448 21.6194L25.2608 8H33V8.46613L30.7642 10.585C30.6695 10.6568 30.5964 10.7526 30.5527 10.8621C30.5091 10.9715 30.4965 11.0906 30.5164 11.2065V26.7908C30.4965 26.9067 30.5091 27.0257 30.5527 27.1352C30.5964 27.2446 30.6695 27.3404 30.7642 27.4123L32.9482 29.5325V30H21.9666V29.5339L24.229 27.3614C24.4516 27.1414 24.4516 27.0767 24.4516 26.7412V14.1435L18.1628 29.9478H17.3144L9.9924 14.1435V24.7365C9.9322 25.1806 10.082 25.6302 10.3984 25.952L13.3398 29.483V29.9478H5V29.483L7.94 25.952C8.09556 25.7926 8.21101 25.5996 8.27712 25.3886C8.34324 25.1775 8.3582 24.9542 8.3208 24.7365V12.488Z",
    fill: "#8CBAFF"
  })
], -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "38",
  height: "38",
  viewBox: "0 0 38 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M28.012 10.9877C27.825 10.89 27.6431 10.7828 27.4668 10.6667C26.9544 10.3241 26.4846 9.92057 26.0675 9.46465C25.0227 8.25641 24.6326 7.03074 24.4898 6.1734H24.4947C24.3754 5.4604 24.4246 5 24.4332 5H19.6767V23.594C19.6767 23.8429 19.6767 24.0905 19.6669 24.3344C19.6669 24.3642 19.6632 24.3916 19.6619 24.4252C19.6619 24.4376 19.6619 24.4526 19.6583 24.4663V24.4775C19.6083 25.1444 19.397 25.7888 19.0429 26.3538C18.6888 26.9188 18.2028 27.3872 17.6277 27.7177C17.0276 28.0628 16.349 28.2438 15.6586 28.2428C13.4434 28.2428 11.6467 26.4161 11.6467 24.1602C11.6467 21.9029 13.4434 20.0763 15.6586 20.0763C16.0783 20.0763 16.4955 20.1435 16.8942 20.2754L16.9003 15.3777C15.6894 15.2197 14.4592 15.3173 13.2874 15.6643C12.1157 16.0112 11.0277 16.6 10.0923 17.3935C9.27255 18.1134 8.5833 18.9724 8.05561 19.9319C7.85501 20.2816 7.09693 21.6889 7.00586 23.971C6.94802 25.2651 7.33321 26.609 7.51658 27.1627V27.1752C7.63103 27.5012 8.07899 28.6161 8.80754 29.5556C9.39505 30.3096 10.0892 30.9721 10.8677 31.5216V31.5092L10.8787 31.5216C13.1801 33.1019 15.7337 32.9986 15.7337 32.9986C16.1755 32.98 17.656 32.9986 19.3371 32.1935C21.2015 31.3001 22.2623 29.9699 22.2623 29.9699C22.9406 29.175 23.4799 28.269 23.8573 27.2909C24.288 26.1461 24.4307 24.7749 24.4307 24.2274V14.3611C24.4886 14.3959 25.2577 14.9098 25.2577 14.9098C25.2577 14.9098 26.3653 15.6278 28.092 16.0944C29.33 16.4267 31 16.4976 31 16.4976V11.7231C30.4154 11.7878 29.2279 11.6012 28.0107 10.989L28.012 10.9877Z",
    stroke: "#8CBAFF",
    "stroke-width": "2",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "38",
  height: "38",
  viewBox: "0 0 38 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M33.3718 12.138C33.202 11.5324 32.8711 10.9841 32.4144 10.5515C31.9449 10.1055 31.3693 9.78651 30.7422 9.62456C28.395 9.00619 18.9913 9.00619 18.9913 9.00619C15.0709 8.96161 11.1516 9.15769 7.25533 9.59333C6.62816 9.76724 6.0537 10.0934 5.58306 10.5427C5.12062 10.9875 4.78567 11.5359 4.61069 12.1368C4.19036 14.4 3.98614 16.6981 4.00077 19C3.98577 21.2998 4.1895 23.5971 4.61069 25.8632C4.78192 26.4616 5.11562 27.0075 5.57931 27.4485C6.043 27.8895 6.62042 28.208 7.25533 28.3767C9.63376 28.9938 18.9913 28.9938 18.9913 28.9938C22.9166 29.0384 26.8409 28.8424 30.7422 28.4067C31.3693 28.2447 31.9449 27.9257 32.4144 27.4797C32.8769 27.0388 33.2056 26.4903 33.3706 25.8932C33.8019 23.6308 34.0116 21.3318 33.9967 19.0287C34.0292 16.7159 33.8197 14.406 33.3718 12.1368V12.138ZM17.2975 22.5691C16.7098 22.8903 16.0017 22.4514 16.0017 21.766V16.2354C16.0017 15.55 16.7099 15.1111 17.2976 15.4324L22.3565 18.1981C22.9816 18.5398 22.9815 19.4626 22.3564 19.8042L17.2975 22.5691Z",
    stroke: "#8CBAFF",
    "stroke-width": "2",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "preloader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Head = _resolveComponent("Head")!
  const _component_layout_block_filter = _resolveComponent("layout-block-filter")!
  const _component_feed_back = _resolveComponent("feed-back")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Head, null, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.getStaticLanguage.blog), 1),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_layout_block_filter, {
              categories: _ctx.getCategoriesBlog,
              "set-categories": _ctx.setCategoriesBlog
            }, null, 8, ["categories", "set-categories"])
          ]),
          (!_ctx.getProcessBlog)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allBlog, (blog) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "blog__element",
                    key: blog.blogId,
                    onClick: _withModifiers(($event: any) => (_ctx.pushTo(blog.blogId)), ["stop","prevent"])
                  }, [
                    _createElementVNode("img", {
                      class: "blog__element_image",
                      src: blog.avatarPath,
                      alt: blog.header
                    }, null, 8, _hoisted_14),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.transformDate(blog.createDate)), 1),
                      _createElementVNode("h3", null, _toDisplayString(blog.header), 1),
                      _createElementVNode("p", _hoisted_17, _toDisplayString(blog.beginning), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "blog__element_icons",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      (blog.mediumUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: blog.mediumUrl,
                            target: "_blank"
                          }, _hoisted_20, 8, _hoisted_18))
                        : _createCommentVNode("", true),
                      (blog.tiktokUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: blog.tiktokUrl,
                            target: "_blank"
                          }, _hoisted_23, 8, _hoisted_21))
                        : _createCommentVNode("", true),
                      (blog.youtubeUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            href: blog.youtubeUrl,
                            target: "_blank"
                          }, _hoisted_26, 8, _hoisted_24))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_13))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_27))
        ])
      ])
    ]),
    _createVNode(_component_feed_back)
  ], 64))
}